<template>
  <el-dialog
    :visible="is_visible"
    ref="dialog"
    :title="metadataTitle"
    :width="popupWidth"
    :close-on-click-modal="false"
    @close="closeDialog"
    class="dialog"
  >
    <div
      class="dialog__content plan-edit"
      v-loading="clickSaveform || dialogLoading"
    >
      <div class="plan-edit__body">
        <div class="body">
          <div class="flex-row body__flex">
            <h3>Редактирование плана согласования</h3>
            <Switcher
              :model="form.show_coordination_term"
              name="stage-times"
              inactive-text="Указание срока у этапов"
              class="body__switcher"
              @switch="
                val => {
                  show_coordination_term = val;
                  this.form.show_coordination_term = val;
                }
              "
            />
          </div>
          <CoordinationPlanStage
            v-for="stage in stages"
            v-show="!stage.deleted"
            ref="stage"
            :key="
              stage.id?.value
                ? stage.id?.value
                : stage.stage_id
                ? stage.stage_id?.value
                : generateStageId(true)
            "
            :options="options"
            :showDeleteStageButton="showDeleteButton"
            :setCoordinationTerm="show_coordination_term"
            :fields="stage"
            :allowChangeExecutionOrder="allowChangeExecutionOrder"
            :getFieldVals="getFieldVals"
            :getObjectWithoutValue="getObjectWithoutValue"
            :hrpac_coordination_request_id="
              fields.hrpac_coordination_request_id?.value
            "
            :deleted="stage.deleted"
            @delete-stage="deleteStage"
          />
          <Button
            buttonSize="big"
            buttonColor="blue"
            hasLeftIcon
            iconName="Plus"
            buttonText="Добавить этап"
            class="plan-edit__add-stage-button"
            @click="addStage"
          />
        </div>
      </div>
    </div>

    <div slot="footer">
      <div class="footer" v-if="metaData.buttons_menu">
        <FormButtons
          v-for="item in metaData.buttons_menu"
          :key="item.id"
          :buttons_menu="[[item]]"
          topPanel
          view-type="detail"
          :breakOnSave="true"
          @get-intent="addFieldsToForm"
          @ClosePopup="closeDialog"
        ></FormButtons>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { store } from '@/store';
// import { eventBus } from '@/bus';
// import { getController } from '@/controllers/request';
import { Dialog } from 'element-ui';
import Button from 'Elements/Button/Button';
import Switcher from 'Elements/Switch/Switch';
import CoordinationPlanStage from 'Parts/Coordination3.0/Plan/Item/CoordinationPlanStage';

import FormButtons from 'Elements/Form/FormButtons';
import {
  mixin,
  form,
  metadata,
  saveForm,
  errorMsg,
  rules,
  parseIntent
} from '@/utils/mixins';
import {
  DEFAULT_FORM_SIZE,
  INTENT_AREA,
  ACTION,
  MODULE,
  EVENTBUS_EVENTS
} from '@/utils/constants';
import { detailView } from '@/utils/helpers';
import { postController } from '@/controllers/request.js';
import { eventBus } from '@/bus';

export default {
  mixins: [mixin, form, metadata, saveForm, rules, parseIntent, errorMsg],
  props: {
    metaData: {
      type: Object
    },
    is_visible: {
      type: Boolean
    },
    fields: {
      type: Object
    }
  },
  created() {
    document.body.style.cssText = `height: auto;
  `;
    console.log('this.fields', this.fields);
    this.stages = [...this.fields.hrpac_coordination_stages?.value];
    this.initiateFields();

    eventBus.$on(EVENTBUS_EVENTS.CLOSE_POPUP, () => {
      this.closeDialog();
    });
  },
  beforeDestroy() {
    eventBus.$off(EVENTBUS_EVENTS.CLOSE_POPUP);
  },
  computed: {
    coord_stages_parsed() {
      return this.fields;
    },
    showDeleteButton() {
      return this.stages.filter(val => val.id && !val.deleted).length > 1;
    },
    setCoordinationTerm() {
      return this.form.show_coordination_term;
    },
    linkToDetailView() {
      return detailView(MODULE.HRPAC_COORDINATION_PLANS, this.fields.id?.value);
    },
    title() {
      return this.fields.hrpac_coordination_scenario_id?.value
        ? 'Редактирование плана согласования'
        : 'Создание плана согласования';
    },
    popupWidth() {
      return store.state.dialog.size;
    },
    metadataTitle() {
      return this.metaData?.title?.main.length &&
        this.metaData?.title?.main[0]?.lbl?.value
        ? this.metaData.title.main[0].lbl?.value
        : '';
    },

    clickSaveform() {
      if (store.state.common.clickSaveform) {
        this.addFieldsToForm();
        store.commit('common/setClickSaveform', false);
      }
      return store.state.common.clickSaveform;
    }
  },
  watch: {
    setCoordinationTerm() {
      this.stages.forEach(stage => {
        stage.coordination_term_int.disabled = !this.setCoordinationTerm;
      });
    }
  },
  data() {
    return {
      processing: false,
      allowChangeExecutionOrder: false,
      stages: {},
      formSize: DEFAULT_FORM_SIZE,
      form: {},
      options: {},
      dialogLoading: false,
      rules: {
        name: {
          required: true,
          message: 'Необходимо заполнить поле',
          trigger: ['blur', 'focus', 'change']
        },
        entity_type: {
          type: 'number',
          required: true,
          message: 'Необходимо заполнить поле',
          trigger: ['blur', 'focus', 'change']
        }
      },
      blocked: {},
      show_coordination_term: false
    };
  },

  methods: {
    async addFieldsToForm(intents) {
      this.dialogLoading = true;
      if (!intents) {
        this.dialogLoading = false;
        return;
      }
      if (intents[0].intentArea === INTENT_AREA.SAVE) {
        this.validateForm();
        store.commit('event/setIntents', intents.slice(1));
      } else {
        store.commit('event/setIntents', intents);
        await this.parse();
      }
      this.dialogLoading = false;
    },
    initiateFields() {
      this.form.id = this.fields.id?.value;
      this.form.hrpac_coordination_request_id =
        this.fields.hrpac_coordination_request_id?.value;
      this.form.hrpac_coordination_scenario_id =
        this.fields.hrpac_coordination_scenario_id?.value;
      this.form.show_coordination_term = Number(
        this.fields.show_coordination_term?.value
      )
        ? true
        : false;
      this.show_coordination_term = this.form.show_coordination_term;
    },
    getFieldVals(fields) {
      let obj = {};
      let keys = Object.keys(fields);
      keys.forEach(el => {
        if (
          !fields[el]?.value ||
          (fields[el]?.value && typeof fields[el]?.value !== 'object')
        ) {
          obj[el] =
            fields[el].type === 'bool'
              ? fields[el]?.value == 1
                ? true
                : false
              : fields[el]?.value;
          if (fields[el].options) this.options[el] = fields[el].options;
        } else {
          let inner = fields[el]?.value;
          let obj1 = [];
          inner.forEach(el1 => {
            obj1.push(this.getFieldVals(el1));
          });
          obj[el] = obj1;
        }
      });
      return obj;
    },
    validateForm() {
      let validationInfo = [];
      let stagesInfo = [];

      this.$refs.stage.forEach(stage => {
        let validationStageData = stage.validateAndGetStageInfo();
        if (validationStageData.formInfo) {
          validationStageData.formInfo.hrpac_coordination_plan_id =
            this.fields.id?.value;
        }
        validationInfo.push(validationStageData.validationResult);

        if (validationStageData.validationResult == 'not valid') {
          stage.$el.classList.add('validationErrorClass');
        } else {
          stage.$el.classList.remove('validationErrorClass');
        }

        if (validationStageData.formInfo) {
          stagesInfo.push(validationStageData.formInfo);
        }
      });
      if (!validationInfo.includes('not valid')) {
        this.form.hrpac_coordination_stages = stagesInfo;
        this.saveForm();
      } else {
        console.log('some form is not valid!');
      }

      const el = document.querySelectorAll('.validationErrorClass'); // элемент к которому скроллим
      window.scrollTo({
        top: el[0]?.offsetTop,
        behavior: 'smooth'
      });
    },
    saveForm() {
      let formData = new FormData();
      const params = {
        module: MODULE.HRPAC_COORDINATION_PLANS,
        action: ACTION.SAVE_PLAN,
        to_pdf: true
      };
      for (let key in params) {
        formData.set(key, params[key]);
      }
      formData.set(
        'coordination_plan',
        JSON.stringify({
          id: this.form.id,
          hrpac_coordination_request_id:
            this.form.hrpac_coordination_request_id,
          hrpac_coordination_scenario_id:
            this.form.hrpac_coordination_scenario_id,
          hrpac_coordination_stages: this.form.hrpac_coordination_stages,
          show_coordination_term: this.form.show_coordination_term
        })
      );
      this.processing = true;
      postController({ options: formData })
        .then(() => {
          this.closeDialog();
          this.parse();
        })
        .catch(err =>
          this.catchError(
            err,
            'Возникла ошибка отправки данных формы. Попробуйте еще раз.',
            'save form'
          )
        )
        .finally(() => {
          this.processing = false;
        });
    },
    changeShowCoordTerm(val) {
      this.form.show_coordination_term = val;
    },
    recalculateExecOrder() {
      let k = 1;
      this.$nextTick(() => {
        for (let i = 1; i <= this.stages.length; i++) {
          if (!this.$refs['stage'][i - 1].form.deleted) {
            this.$refs['stage'][i - 1].form.execution_order = k.toString();
            k++;
          }
        }
      });
    },
    addStage() {
      let newStage = {
        id: {
          name: 'id',
          type: 'id',
          value: ''
        },
        stage_id: {
          value: this.generateStageId()
        },
        name: this.getObjectWithoutValue(
          this.fields.hrpac_coordination_stages?.value[0].name
        ),
        execution_order: this.getObjectWithoutValue(
          this.fields.hrpac_coordination_stages?.value[0].execution_order
        ),
        operator: this.getObjectWithoutValue(
          this.fields.hrpac_coordination_stages?.value[0].operator
        ),
        coordination_term_int: this.getObjectWithoutValue(
          this.fields.hrpac_coordination_stages?.value[0].coordination_term_int
        ),
        hrpac_coordination_stage_result: this.getObjectWithoutValue(
          this.fields.hrpac_coordination_stages?.value[0]
            .hrpac_coordination_stage_result
        )
      };
      newStage.coordination_term_int.disabled = !this.setCoordinationTerm;
      this.stages = [...this.stages, newStage];
      this.recalculateExecOrder();
    },
    deleteStage(stageId) {
      let stageToDelete = this.stages.find(el => {
        return el.stage_id
          ? el.id?.value.includes(stageId) ||
              el.stage_id?.value.includes(stageId)
          : el.id?.value.includes(stageId);
      });
      stageToDelete.id?.value
        ? this.$set(
            this.stages[this.stages.indexOf(stageToDelete)],
            'deleted',
            true
          )
        : this.stages.splice(this.stages.indexOf(stageToDelete), 1);

      this.recalculateExecOrder();
    },
    getObjectWithoutValue(object) {
      let newObj = {};
      if (object.name != 'hrpac_coordination_stage_result') {
        Object.keys(object).forEach(field => {
          field == 'value'
            ? (newObj[field] = '')
            : (newObj[field] = object[field]);
        });
      } else {
        Object.keys(object).forEach(field => {
          if (field != 'value') {
            newObj[field] = object[field];
          } else {
            let newInnerObject = {};
            Object.keys(object[field][0]).forEach(val => {
              newInnerObject[val] = this.getObjectWithoutValue(
                object[field][0][val]
              );
            });
            newObj[field] = [newInnerObject];
          }
        });
      }
      return newObj;
    },
    generateStageId(first) {
      let num = 0;
      let stageId = '';
      let finish = false;
      do {
        stageId = `stage${num}`;
        this.stages.find(el => {
          return el.stage_id ? el.stage_id?.value.includes(stageId) : false;
        })
          ? num++
          : (finish = true);
      } while (!finish);
      if (first)
        this.stages[0].stage_id = {
          value: stageId
        };
      this.stages[0].execution_order.value = 0;
      return stageId;
    },

    closeDialog() {
      store.commit('dialog/setRemoveDialogData');
      this.$emit('cancel-callback');
    }
  },
  components: {
    'el-dialog': Dialog,
    FormButtons,
    Button,
    Switcher,
    CoordinationPlanStage
  }
};
</script>
<style lang="scss" scoped>
#front .dialog {
  & ::v-deep .el-dialog {
    padding: 0;

    &__header {
      padding: 20px 24px !important;
      border-bottom: 1px solid $black-20;
    }

    &__footer {
      width: 100%;
      padding: 20px 24px !important;
      margin-top: 0;
      border-top: 1px solid $black-20;

      .footer {
        width: 230px;
      }
    }
  }
}

.el-dialog {
  text-align: left;
}

.style-fix {
  height: auto !important;
  background-color: $background-dove;
}

.plan-edit {
  &__top {
    background-color: $background-dove;
    position: sticky;
    top: 56px;
    width: 1200px;
    z-index: 1000;
    vertical-align: middle;
    padding: 16px 0;

    &.scroll {
      position: fixed;
    }

    .top {
      background: $white;
      border-radius: 6px;
      max-height: 160px;
      position: relative;
      width: 100%;
      align-items: center;
      padding: 16px;

      &-title {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &__name {
          color: $black-200;
          font-weight: bold;
          font-size: 24px;
          line-height: 32px;
          margin: 0;
          width: fit-content;
          padding: 0;
        }
      }
    }

    .buttons-panel {
      width: fit-content;
    }
  }

  &__body {
    background-color: $background-dove;
    position: relative;
    width: 100%;
    vertical-align: middle;

    .body {
      background: $white;
      border-radius: 6px;
      position: relative;
      width: 100%;
      text-align: left;
      align-items: center;

      &__switcher {
        height: 24px;
      }

      &__flex {
        justify-content: space-between;
      }

      .plan-edit__add-stage-button {
        margin-top: 16px;
        width: 100%;
      }
    }
  }

  &__form {
    &-name {
      width: 220px;
    }

    &-entity-type {
      margin-left: 16px;
      width: 324px;

      .el-form-item {
        width: 324px;
      }
    }

    &-is-primary {
      padding-top: 28px;
      margin-left: 16px;
    }
  }

  .application-form {
    background: #fff;
    border-radius: 6px;
    position: relative;
    overflow-y: auto;
    display: block;

    &::-webkit-scrollbar {
      width: 0px !important;
    }

    .el-form__section {
      text-align: left;
      margin-top: 8px;

      h4 {
        color: $black-200;
        font-weight: bold;
        font-size: 18px;
        line-height: 28px;
        margin: 0;
        width: fit-content;
        padding: 0;
        margin-top: 20px;
        margin-bottom: 16px;
      }

      .flex-row {
        justify-content: space-between;

        .application-form__section-column {
          width: 50%;
          max-width: 544px;
        }

        .application-form__section-row {
          width: 100%;
        }

        .el-form-item__content {
          margin-left: 0 !important;
          width: 100%;
        }

        .el-form-item {
          margin-bottom: 0 !important;

          .label {
            font-weight: normal;
            font-size: 14px;
            line-height: 24px;
            color: $black-200;
          }
        }

        &:last-child ::v-deep .el-form-item {
          margin-bottom: 0;
        }

        & ::v-deep .el-checkbox,
        & ::v-deep .el-radio {
          max-height: unset;
          height: 28px;
          align-items: center;
          // margin: 0;
          // margin-bottom: 40px;
        }
      }
    }
  }

  .el-form-item--hidden {
    display: none;
  }

  .no-margin {
    padding: 0;
    margin-left: 0;
    display: flex;

    .sub-fields {
      .el-form-item__content {
        display: flex;
      }
    }

    .el-form-item {
      margin: 0;
    }

    .el-form-item__content {
      margin-left: 0 !important;
    }
  }

  .el-form-item {
    width: 100% !important;

    &__error {
      top: initial;
    }
  }

  .el-form-item__label {
    display: contents;
    width: 100%;
    text-align: left !important;
    line-height: 24px !important;
  }
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.dialog__content {
  // max-height: 100vh;
  max-height: 100%;

  .open {
    display: block;
  }

  .hide {
    display: none;
  }
}
</style>

<style lang="scss">
.field {
  width: 50% !important;
}

.flex-row {
  display: flex;
  width: 100%;
}
</style>
